module.exports = __webpack_public_path__ + "img/LCD_colorbar_test_highlight.c31bf468.png";